module.exports = __webpack_public_path__ + "img/vigilado.991a5992.png";